import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'assets/main.css'
import 'assets/style.scss'
import 'assets/components.scss'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-lazy-load-image-component/src/effects/blur.css'
import 'react-loading-skeleton/dist/skeleton.css'

ReactDOM.render(
  <BrowserRouter>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      theme="light"
      toastStyle={{
        backgroundColor: '#ffffff',
        color: '#1f2937',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow:
          '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        border: '1px solid #e5e7eb',
        minHeight: '64px',
      }}
    />
  </BrowserRouter>,
  document.getElementById('root')
)
